import * as React from "react";
import { IEventTypeNode } from "../../models/event/eventTypeNode";

//EventEventTypeSummaryListLine
//***************************************************************
export interface IEventEventTypeSummaryListLineProp {
    eventTypeNode: IEventTypeNode;
}

export class EventEventTypeSummaryListLine extends React.Component<IEventEventTypeSummaryListLineProp, {}> {
    render() {
        const eventTypeNode = this.props.eventTypeNode;
        return (
            <div className="line">
                <div className="row">
                    <div className={"col col-12"}>
                        <div className="singleLine">{eventTypeNode ? eventTypeNode.getPathName() : ""}</div>
                    </div>
                </div>
            </div>
        );
    }
}

//EventEventTypeSummaryList
//***************************************************************
export interface IEventEventTypeSummaryListProp {
    title: string;
    eventTypeNodes: IEventTypeNode[];
}

export class EventEventTypeSummaryList extends React.Component<IEventEventTypeSummaryListProp, { }> {
    render() {
        const props = this.props;
        const eventTypeNodes = props.eventTypeNodes;
        const eventList = eventTypeNodes.length > 0
            ? <div className="lineContainer eventEventTypes">
                {eventTypeNodes.map((eventTypeNode) =>
                    <EventEventTypeSummaryListLine
                        key={eventTypeNode.id}
                        eventTypeNode={eventTypeNode}
                    />
                )}
            </div>
            : null;
        return (
            <div className="">
                <label className="control-label">{props.title}</label>
                { eventList }
            </div>
        );
    }
}